import { ImageOff } from "lucide-react";

import { cn } from "@/shared/lib/utils";

/** 节点树 / 编辑区里独立图片块的提示字(1009 C 线:A 线起每个图片位都能配图,不再一律说「暂无图片」)。 */
export const IMAGE_SLOT_HINT = "图片在「各页面图片位」里设置";

/**
 * 独立图片块(`image0` 这类,不是卡片槽位)的占位。A.51 时这些位置没有图的来源、一律「暂无图片」;
 * 1009 A 线起每个图片位都能上传 / 选图 / 自动配图(「各页面图片位」面板),这里只说图在哪儿设置 ——
 * 再写「暂无图片」会让配过图的客户以为没生效。没配的位置发布后宿主显示「暂无图片」(面板里逐格写明)。
 */
export function NoImagePlaceholder({ className }: { className?: string }) {
  return (
    <div
      role="img"
      aria-label={IMAGE_SLOT_HINT}
      title="在「各页面图片位」里给这个位置上传或选图;没配的发布后显示「暂无图片」(模板原图会被清空)"
      className={cn(
        "mt-1 flex h-10 items-center justify-center gap-1.5 rounded-md border border-dashed border-border bg-muted/40 text-2xs text-muted-foreground",
        className
      )}
    >
      <ImageOff className="h-3.5 w-3.5" aria-hidden />
      {IMAGE_SLOT_HINT}
    </div>
  );
}
